/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NarrativeType } from './NarrativeType';
import {
    NarrativeTypeFromJSON,
    NarrativeTypeFromJSONTyped,
    NarrativeTypeToJSON,
    NarrativeTypeToJSONTyped,
} from './NarrativeType';
import type { NarrativeClassifierType } from './NarrativeClassifierType';
import {
    NarrativeClassifierTypeFromJSON,
    NarrativeClassifierTypeFromJSONTyped,
    NarrativeClassifierTypeToJSON,
    NarrativeClassifierTypeToJSONTyped,
} from './NarrativeClassifierType';

/**
 * Request model for updating an existing narrative
 * @export
 * @interface NarrativeUpdate
 */
export interface NarrativeUpdate {
    /**
     * 
     * @type {string}
     * @memberof NarrativeUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeUpdate
     */
    userPrompt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeUpdate
     */
    systemPrompt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeUpdate
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeUpdate
     */
    modelName?: string | null;
    /**
     * 
     * @type {NarrativeClassifierType}
     * @memberof NarrativeUpdate
     */
    classifierType?: NarrativeClassifierType | null;
    /**
     * 
     * @type {NarrativeType}
     * @memberof NarrativeUpdate
     */
    narrativeType?: NarrativeType | null;
}



/**
 * Check if a given object implements the NarrativeUpdate interface.
 */
export function instanceOfNarrativeUpdate(value: object): value is NarrativeUpdate {
    return true;
}

export function NarrativeUpdateFromJSON(json: any): NarrativeUpdate {
    return NarrativeUpdateFromJSONTyped(json, false);
}

export function NarrativeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NarrativeUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'userPrompt': json['user_prompt'] == null ? undefined : json['user_prompt'],
        'systemPrompt': json['system_prompt'] == null ? undefined : json['system_prompt'],
        'version': json['version'] == null ? undefined : json['version'],
        'modelName': json['model_name'] == null ? undefined : json['model_name'],
        'classifierType': json['classifier_type'] == null ? undefined : NarrativeClassifierTypeFromJSON(json['classifier_type']),
        'narrativeType': json['narrative_type'] == null ? undefined : NarrativeTypeFromJSON(json['narrative_type']),
    };
}

export function NarrativeUpdateToJSON(json: any): NarrativeUpdate {
    return NarrativeUpdateToJSONTyped(json, false);
}

export function NarrativeUpdateToJSONTyped(value?: NarrativeUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'user_prompt': value['userPrompt'],
        'system_prompt': value['systemPrompt'],
        'version': value['version'],
        'model_name': value['modelName'],
        'classifier_type': NarrativeClassifierTypeToJSON(value['classifierType']),
        'narrative_type': NarrativeTypeToJSON(value['narrativeType']),
    };
}

